<script>
export default {
  inject: ["gsap"],
  name: "OnlineForm",
  data(){
    return {
      text: null,
      phone: null,
      name: null,
    }
  },
  methods:{
    postSendMessage(){
      axios.post('/api/online-form/send',
          {
            text: this.text,
            phone: this.phone,
            name: this.name
          })
          .then(response => {
            this.text = null
            this.name = null
            this.phone = null
          })
          .catch(error => {
            console.error('Ошибка при получении профиля:', error);
          });
    }
  },
  mounted() {
    var element = $(".lead-magnit")
    this.gsap.to('.lead-magnit', {
      duration: 2,
      delay:2,
      scrollTrigger: {
        trigger: element, // Элемент, который будет триггером
        start: "top center", // Когда триггер сработает (например, когда верх элемента достигнет центра экрана)
        toggleClass: "active", // Добавляем/убираем класс "active" при срабатывании триггера
        once:true
      }
    });

  }
}
</script>

<template>
  <div class="lead-magnit left mobile-nv" id="lead-form">
    <svg class="left-blue-line-mob mobile" width="64" height="306" viewBox="0 0 64 306" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M-41.2317 300.008C-46.7265 328.289 1.05511 44.6899 42.6042 142.282C84.1533 239.874 58.747 -45.1229 -108.36 12.0353" stroke="#A6CFF2" stroke-width="7" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg class="lm-blue-line mobile-nv" width="199" height="525" viewBox="0 0 199 525" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M302.982 509.672C332.281 549.873 47.499 139.978 53.8269 322.693C60.1548 505.409 -108.567 44.6942 194.988 12.5169" stroke="#A6CFF2" stroke-width="24" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg class="orange-arrow-mob" width="283" height="353" viewBox="0 0 283 353" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M51.8978 314.479C34.9603 325.482 61.5558 341.108 60.5066 342.272M60.5066 342.272C59.6104 343.266 53.4121 338.399 30.8387 348.689M60.5066 342.272C-90.6638 274.352 136.873 140.881 250.229 238.693C363.585 336.506 113.539 240.56 15.3122 159.054C-82.9144 77.5474 0.751849 -62.8115 195.209 41.5967" stroke="#FF9166" stroke-width="7" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div class="lead-form-box left">
      <div class="lead-form left flex flex-y-center flex-column">
        <svg class="yellow-line-form-mob mobile" width="153" height="8" viewBox="0 0 153 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M153 0L4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8L153 8V0Z" fill="#FFE866"/>
        </svg>
        <svg class="blue-line-wave-left mobile" width="64" height="306" viewBox="0 0 64 306" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M-41.2317 300.008C-46.7265 328.289 1.05511 44.6899 42.6042 142.282C84.1533 239.874 58.747 -45.1229 -108.36 12.0353" stroke="#A6CFF2" stroke-width="7" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg class="blue-line-wave-right mobile" width="63" height="303" viewBox="0 0 63 303" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M97.9459 297.795C101.953 326.325 69.0792 40.6139 22.4795 135.898C-24.1202 231.181 16.1669 -52.0952 180.053 13.7304" stroke="#A6CFF2" stroke-width="7" stroke-miterlimit="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="lm-head">Остались вопросы, напишите нам</span>
        <span class="lm-desc">Заполните форму или свяжитесь с нами любым удобным для вас способом</span>
        <input v-model="name" class="input-text" type="text" placeholder="Ваше имя">
        <input v-model="phone" class="input-num" type="text" placeholder="+7 999 999 99 99" v-mask="'+7(###) ###-##-##'">
        <div class="textarea-container left">
          <textarea v-model="text"  placeholder="Какой у вас вопрос?"></textarea>
          <div class="textarea-container-icons right flex">
            <a href="https://api.whatsapp.com/send/?phone=79163856000&text&type=phone_number&app_absent=0" target="_blank" class="icon-circle left flex flex-xy-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23.1998C18.1856 23.1998 23.2001 18.1854 23.2001 11.9998C23.2001 5.81422 18.1856 0.799805 12 0.799805C5.81446 0.799805 0.800049 5.81422 0.800049 11.9998C0.800049 14.0085 1.32885 15.8937 2.25483 17.5238L0.800049 23.1998L6.65194 21.8428C8.24115 22.7082 10.0632 23.1998 12 23.1998ZM12 21.4767C17.234 21.4767 21.477 17.2338 21.477 11.9998C21.477 6.76584 17.234 2.52288 12 2.52288C6.76609 2.52288 2.52313 6.76584 2.52313 11.9998C2.52313 14.0207 3.15565 15.8938 4.23352 17.432L3.38466 20.6152L6.62399 19.8054C8.15154 20.8595 10.0037 21.4767 12 21.4767Z" fill="white"/>
                <path d="M9.37492 6.88897C9.10863 6.35411 8.70012 6.40146 8.28744 6.40146C7.54991 6.40146 6.3999 7.28489 6.3999 8.92903C6.3999 10.2765 6.99366 11.7515 8.99444 13.958C10.9253 16.0874 13.4624 17.1889 15.5687 17.1514C17.6749 17.1139 18.1083 15.3014 18.1083 14.6893C18.1083 14.418 17.9399 14.2827 17.8239 14.2459C17.1062 13.9014 15.7824 13.2596 15.4812 13.139C15.18 13.0184 15.0227 13.1815 14.9249 13.2702C14.6518 13.5305 14.1103 14.2977 13.9249 14.4702C13.7395 14.6428 13.4631 14.5555 13.3481 14.4902C12.9248 14.3204 11.7772 13.8099 10.8625 12.9232C9.73116 11.8265 9.66477 11.4492 9.45162 11.1133C9.28111 10.8446 9.40623 10.6798 9.46867 10.6077C9.71242 10.3265 10.049 9.89225 10.1999 9.67647C10.3509 9.46069 10.231 9.13308 10.1591 8.92903C9.84992 8.05147 9.58795 7.31686 9.37492 6.88897Z" fill="white"/>
              </svg>
            </a>
            <a class="icon-circle left flex flex-xy-center" href="https://t.me/BizArenda" target="_blank">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" href="https://t.me/BizArenda" target="_blank">
                <path d="M25.6679 7.47583L22.197 23.0901C21.9352 24.1921 21.2523 24.4663 20.2818 23.9473L14.9934 20.2297L12.4417 22.571C12.1594 22.8403 11.9231 23.0657 11.3789 23.0657L11.7588 17.9277L21.5604 9.47902C21.9865 9.11662 21.468 8.91578 20.898 9.27822L8.78088 16.5563L3.56432 14.9989C2.42962 14.6609 2.40912 13.9164 3.80047 13.3973L24.2046 5.89876C25.1492 5.56084 25.9759 6.09952 25.6679 7.47583Z" fill="white"/>
              </svg>
            </a>
          </div>
        </div>
        <button class="orange-big-btn">Отправить сообщение</button>
        <div class="contact-under-btn left flex flex-xy-center">
          <span>+7 499 715 10 60</span>
          <span>info@rented77.ru</span>
        </div>
        <span class="cub-legal">*Нажимая кнопку, вы соглашаетесь на обработку персональных данных</span>
      </div>
      <div class="lm-containers-img left mobile-nv">
        <div class="container-img left">
          <img src="/assets/lead-img-1.png" alt="">
        </div>
        <div class="container-img left">
          <img src="/assets/lead-img-2.png" alt="">
        </div>
        <div class="container-img left">
          <img src="/assets/lead-img-3.png" alt="">
        </div>
        <div class="container-img left">
          <img src="/assets/lead-img-4.png" alt="">
        </div>
      </div>
      <svg class="orange-zig-zag mobile" width="375" height="150" viewBox="0 0 375 150" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M-179 4L95.5855 145.754C96.412 146.18 97.3223 145.346 96.9696 144.486L48.7911 26.9303C48.4728 26.1535 49.1953 25.3539 50.0003 25.5922L349.838 114.36C350.669 114.606 351.399 113.749 351.023 112.968L302.97 13.0179C302.595 12.2385 303.32 11.3831 304.15 11.6243L457 56" stroke="#FF9166" stroke-width="7"/>
      </svg>
    </div>
  </div>
</template>

<style scoped>

</style>